import ShortLink from "../views/shortLink/short-link";

export default [
  {
    path: "/s/:code",
    name: "shortLink",
    component: ShortLink
  },
];



// WEBPACK FOOTER //
// ./src/router/shortLink.js